module.exports = __webpack_public_path__ + "static/media/pra-qing.07a3ca6e.png";